import React, { useState, useContext, useEffect } from 'react'
import { useTranslation, Trans } from 'react-i18next'

import email_active from 'img/auth-and-sign-icons/email-active.svg'
import email_inactive from 'img/auth-and-sign-icons/email-inactive.svg'
import sms_active from 'img/auth-and-sign-icons/sms-active.svg'
import sms_inactive from 'img/auth-and-sign-icons/sms-inactive.svg'
import mobileapp_active from 'img/auth-and-sign-icons/mobileapp-active.svg'
import mobileapp_inactive from 'img/auth-and-sign-icons/mobileapp-inactive.svg'

import sddService from 'selfServicePortal/services/CreditCardServices/sddService'

import { OtpDistributionChannel } from 'selfServicePortal/interfaces/i-api-sdd'
import { SddDispatchContext, SDD_ACTIONS } from '../../SDDMultistepValues'
import { AuthContext } from '../SDDAuthentication'

interface IAuthenticationButtons {
	otpDistributionChannel: OtpDistributionChannel
	iconActive: string
	iconInactive: string
	title: string
	className: string
	show: boolean
}

const otpAuthMethods: IAuthenticationButtons[] = [
	{
		otpDistributionChannel: OtpDistributionChannel.Email,
		iconActive: email_active,
		iconInactive: email_inactive,
		title: 'SDDVerificationMethodEmail',
		className: 'email-otp',
		show: true,
	},
	{
		otpDistributionChannel: OtpDistributionChannel.SMS,
		iconActive: sms_active,
		iconInactive: sms_inactive,
		title: 'SDDVerificationMethodSms',
		className: 'sms-otp',
		show: true,
	},
	{
		otpDistributionChannel: OtpDistributionChannel.PushNotification,
		iconActive: mobileapp_active,
		iconInactive: mobileapp_inactive,
		title: 'SDDVerificationMethodApp',
		className: 'push-notification',
		show: false,
	},
]

export const AuthSelectButtons = () => {
	const { t } = useTranslation()
	const [sdd, dispatchSdd] = useContext(SddDispatchContext)
	const {
		otpSessionResponse,
		setOtpSessionResponse,
		setLoading,
		setErr,
		authSelect,
		setAuthSelect,
	} = useContext(AuthContext)
	const [authType, setAuthType] = useState<OtpDistributionChannel>(
		OtpDistributionChannel.Unknown
	)

	useEffect(() => {
		dispatchSdd({
			type: SDD_ACTIONS.SET_AUTH_SELECT,
			payload: {
				authSelect: authSelect,
			},
		})
	}, [authSelect, dispatchSdd])

	useEffect(() => {
		dispatchSdd({
			type: SDD_ACTIONS.SET_DESCRIPTION,
			payload: {
				description: 'SDDSelectVerificationMethodSubtitle',
			},
		})
	}, [dispatchSdd])

	async function getAuthOtp() {
		setLoading(true)
		try {
			sddService
				.sddEnrollmentInitiate({
					customerId: sdd.customerId,
					title: sdd.title,
					firstName: sdd.firstName,
					lastName: sdd.lastName,
					emailAddress: sdd.emailAddress,
					phoneNumber: sdd.phoneNumber,
					distributionChannel: authType,
					market: sdd.market,
				})
				.then((response) => {
					if (response.status === 200) {
						setOtpSessionResponse(response.data)
						setAuthSelect(false)
						setLoading(false)
					}
				})
				.catch((error) => {
					console.warn(error)
					setLoading(false)
					setErr(true)
				})
		} catch (error) {
			console.warn(error)
			setLoading(false)
			setErr(true)
		}
	}

	async function resendOtp() {
		setLoading(true)
		try {
			sddService
				.sddResendOtp({
					sessionId: sdd.sessionId,
					customerId: sdd.customerId,
					title: sdd.title,
					firstName: sdd.firstName,
					lastName: sdd.lastName,
					emailAddress: sdd.emailAddress,
					phoneNumber: sdd.phoneNumber,
					distributionChannel: authType,
					market: sdd.market,
				})
				.then((response) => {
					if (response.status === 200) {
						setOtpSessionResponse(response.data)
						setOtpData()
						setAuthSelect(false)
						setLoading(false)
					}
				})
				.catch((error) => {
					console.log(error)
					setErr(true)
					setLoading(false)
				})
		} catch (error) {
			console.log('Error catch:', error)
			setErr(true)
			setLoading(false)
		}
	}

	function setOtpData() {
		dispatchSdd({
			type: SDD_ACTIONS.SET_OTP_INFO,
			payload: {
				otpDistributedToContactInfo:
					otpSessionResponse?.otpDistributedToContactInfo,
				sessionId: otpSessionResponse?.sessionId,
				expiryAtUtc: otpSessionResponse?.expiryAtUtc,
			},
		})
	}

	function setAuth(state: any) {
		setLoading(true)
		dispatchSdd({
			type: SDD_ACTIONS.SET_DISTRIBUTION_CHANNEL,
			payload: {
				distributionChannel: authType,
			},
		})
		if (state.sessionId === '' || state.sessionId === undefined) {
			getAuthOtp()
		} else {
			resendOtp()
		}
	}

	const isActive = (method: OtpDistributionChannel) => method === authType

	return (
		<div className="sdd-otp-method-select-section">
			<>
				<div>{t('SDDSelectVerificationMethodText')}</div>
				<div className="otp-select-btn-section">
					{otpAuthMethods.map((item) => {
						if (item.show) {
							return (
								<div
									className={`otp-method-btn ${
										isActive(item.otpDistributionChannel)
											? ' active'
											: ''
									}`}
									onClick={() =>
										setAuthType(item.otpDistributionChannel)
									}>
									<img
										src={`${
											isActive(
												item.otpDistributionChannel
											)
												? item.iconActive
												: item.iconInactive
										}`}
										className={item.className}
										alt={`${item.className} icon`}
									/>{' '}
									<Trans t={t} i18nKey={item.title}>
										Button <wbr /> name
									</Trans>
								</div>
							)
						}
						// eslint-disable-next-line array-callback-return
						return
					})}
				</div>
				<button
					className="btn btn-primary send-auth-code-btn"
					disabled={authType === OtpDistributionChannel.Unknown}
					onClick={() => setAuth(sdd)}>
					{t('SendAuthenticationCode')}
				</button>
			</>
		</div>
	)
}
